import { useState } from 'react'

import ChartSearchBar from './components/ChartSearchBar'
import { ChatMessages } from './components/ChatMessages'
import { ChatSideBar } from './components/ChatSideBar'

const ChatPage = () => {
    const [searchBarVisible, setSearchBarVisible] = useState<boolean>(false)
    return (
        <main className="content">
            <div className="px-container">
                <section className="chat-section section-fullscreen">
                    {searchBarVisible ? (
                        <ChartSearchBar searchAction={setSearchBarVisible} />
                    ) : (
                        <ChatSideBar />
                    )}
                    <ChatMessages searchAction={setSearchBarVisible} />
                </section>
            </div>
        </main>
    )
}
export default ChatPage
